"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageService = void 0;
var _Core = _interopRequireDefault(require("../dragon/store/Core"));
var _errorReporter = require("./errorReporter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LanguageService = exports.LanguageService = /*#__PURE__*/_createClass(function LanguageService() {
  var _this = this;
  _classCallCheck(this, LanguageService);
  _defineProperty(this, "_translations", {});
  _defineProperty(this, "registerTranslations", function (lang, translations) {
    _this._translations[lang] = translations;
  });
  _defineProperty(this, "translate", function (key) {
    var language = _Core["default"].getState().config.locale;
    if (!_this._translations[language]) {
      console.error("missing language " + language);
      return "INVLANG";
    }
    var t = _this._translations[language][key];
    if (!t) {
      (0, _errorReporter.reportError)("Missing Translation " + key + " in language " + language);
      console.warn("missing translation " + key);
    }
    return t ? t : "MISSING";
  });
} // window["LanguageService"] = this;
);
//# sourceMappingURL=languageService.js.map